export var getListIndoorMapsUrl = function () {
    var _a;
    // const configApi = platformApis.find(
    //   ({ api, version }) => api === "config" && version === "v1"
    // );
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v1/maps");
};
export var getCollectionsUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v1/collections");
};
export var getDraftsUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v1/drafts");
};
export var getConfigurationUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v1/configuration");
};
export var getCatalogUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CATALOG_URL, "/config/v1/catalogs");
};
export var getLayersUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_LAYERS_URL, "/interactive/v1/catalogs");
};
export var getMice2MoMUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_MICE_2_MOM_URL, "/mice2mom");
};
/**
 * Stores url in const to get interactive layer url
 * @returns interactive layer url
 */
export var getInterativeLayer = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_LAYERS_URL, "/interactive/v1/");
};
/**
 * Stores blob store url in the const to be used for api calls
 * @returns blob store url
 */
export var getBlobStoreUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_BLOBSTORE_URL, "/v2/catalogs");
};
/**
 * Stores metadata url in the const to be used for api calls
 * @returns snow ticket url
 */
export var getMetaDataUrl = function () {
    var _a;
    return "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_METADATA_URL, "/v1/catalogs");
};
